import { BaseApi } from 'Core/api/BaseApi'

export class Api extends BaseApi {
  getPromoRequest = async ({ userId, token, promoRequestId }) => {
    try {
      const { body } = await Api.get(`/v2/promorequest`, { userId, token, promoRequestId })
      return body && !body.errors && body.id && body.ad && body.adCode && body.promoRequestListing ? body : null
    } catch (e) {
      return null
    }
  }

  createBankartTransaction = async (fields) => {
    const defaultResult = { status: Api.responseTypes.ERROR }

    try {
      const { body } = await Api.post('/v2/transaction/debit', fields)

      return body
    } catch (error) {
      console.log('createBankartTransaction error', error)
      return defaultResult
    }
  }
}
